import { render } from "./Manual.vue?vue&type=template&id=578adbab&scoped=true"
import script from "./Manual.vue?vue&type=script&lang=js"
export * from "./Manual.vue?vue&type=script&lang=js"

import "./Manual.vue?vue&type=style&index=0&id=578adbab&lang=scss&scoped=true"

import exportComponent from "/Users/nicorivera/Documents/NR/Sate/sate2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578adbab"]])

export default __exports__